import { isValid, parseISO, subMonths } from 'date-fns';

export const REGISTRATION_FRESHNESS_MONTHS = 2;

export interface PhoneConfirmationParams {
  updatedAt?: string;
  phoneConfirmedAt?: string;
  phoneUpdatedAt?: string | null;
  now?: Date;
}

function parseTimestamp(timestamp?: string | null): Date | undefined {
  if (!timestamp) {
    return undefined;
  }

  const parsed = parseISO(timestamp);

  return isValid(parsed) ? parsed : undefined;
}

export function requiresPhoneConfirmation({
  updatedAt,
  phoneConfirmedAt,
  phoneUpdatedAt,
  now = new Date(),
}: PhoneConfirmationParams): boolean {
  const threshold = subMonths(now, REGISTRATION_FRESHNESS_MONTHS);

  const isPhoneUpToDate = [phoneConfirmedAt, phoneUpdatedAt]
    .map(parseTimestamp)
    .some((timestamp) => timestamp && timestamp >= threshold);

  if (isPhoneUpToDate) {
    return false;
  }

  const registrationUpdatedAt = parseTimestamp(updatedAt);

  if (!registrationUpdatedAt) {
    return false;
  }

  return registrationUpdatedAt < threshold;
}
